import axiosInstance from "../axiosInterceptor";

export async function getCategoriesBlogsPagination(payload) {
  const response = await axiosInstance.post(`admin/blogsCategory/getCategoriesBlogsPagination`, payload);
  const data = response?.data;
  return data;
}

export async function getBlogByURL(url) {
  const response = await axiosInstance.get(`admin/blogs/getBlogByURL/${url}`);
  const data = response?.data;
  return data;
}
